// src/app/layout/nav-items.ts
import {
  LayoutDashboard,
  Users,
  Server,
  ShoppingCart,
  Wallet,
  Percent,
  LifeBuoy,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /**
   * Optional permission key for a future permission-gated sidebar.
   * Not read or enforced anywhere yet — just reserving the field so
   * adding real permission checks later doesn't require touching
   * every item's shape again.
   */
  permission?: {
  module: string;
  action: string;
};
  /**
   * Optional visual grouping label. Purely a render-time hint for the
   * sidebar (adjacent items sharing the same section get a small label
   * above them) — it is NOT a new data structure. Items must stay in
   * section order in this array for grouping to render correctly.
   */
  section?: string;
}

// Single source of truth for the sidebar. To add, remove, or reorder
// a menu item, edit this array — nothing else needs to change.
export const NAV_ITEMS: NavItem[] = [
  { label: 'داشبورد', to: '/dashboard', icon: LayoutDashboard, section: 'نمای کلی' },
  { label: 'مشتریان', to: '/customers', icon: Users, section: 'عملیات', permission: { module: 'customers', action: 'view' } },
  { label: 'سرویس‌ها', to: '/services', icon: Server, section: 'عملیات', permission: { module: 'services', action: 'view' } },
  { label: 'سفارش‌ها', to: '/orders', icon: ShoppingCart, section: 'عملیات', permission: { module: 'orders', action: 'view' } },
  { label: 'کیف پول', to: '/wallet', icon: Wallet, section: 'مالی', permission: { module: 'wallet', action: 'view' } },
  { label: 'کمیسیون', to: '/commission', icon: Percent, section: 'مالی', permission: { module: 'commission', action: 'view' } },
  { label: 'پشتیبانی', to: '/support', icon: LifeBuoy, section: 'دیگر', permission: { module: 'support', action: 'view' } },
  { label: 'تنظیمات', to: '/settings', icon: Settings, section: 'دیگر' },
];
